import { ReportStatusCounts } from 'src/features/monitoringDashboardAlpha/types'

/**
 * 実施率を算出する（0〜100 のパーセント値）
 *
 * 定義: 実施済み(期限内+期限後) / (全件数 − 開始前)
 * - まだ期限の来ていない「開始前」は母数から除外する
 *   （未着手をもって実施率が下がらないようにするため）。
 * - 母数が 0 の場合は 0% とする。
 * - 100% は全件実施済みのときだけ。母数が多い場合に四捨五入で
 *   未完了が残っているのに 100% と表示されるのを防ぐため、
 *   完全達成でない限り最大 99% に丸める。
 *
 * 実施率はレスポンスに含まれないため、フロントエンドで算出する。
 */
export const computeSubmissionRate = (counts: ReportStatusCounts): number => {
  const submitted = counts.implemented + counts.implementedAfterDeadline
  // 開始前を除いた母数（実施済み + 未実施 + 期間中 相当）
  const denominator = counts.total - counts.notStarted
  if (denominator <= 0) return 0
  if (submitted >= denominator) return 100
  // 未完了が残っている場合は、四捨五入で 100% に達しても 99% に留める
  return Math.min(99, Math.round((submitted / denominator) * 100))
}
